import React, { Component } from 'react';
import InstallmentGuidelines from './InstallmentGuidelines'

class PaymentPlans extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            continuityMonths: this.props.paymentPlan === 'month' ? this.props.paymentInstallments || 4 : 4,
            installmentAlertType: "alert alert-info",
            maximumMonths: 4
        };
        
        this.continuityMonthsInput = null;
        this.setContinuityMonthsInputRef = element => this.continuityMonthsInput = element;
        
        this.selectFullPayment = this.selectFullPayment.bind(this);
        this.calculateMonthlyPayments = this.calculateMonthlyPayments.bind(this);
    }
    
    calculateMonthlyPayments(){
        var continuityMonths = document.getElementById('continuityMonths');
        let installmentAmounts = {};
        Object.entries(this.props.fullPayAmounts).forEach(([key, value]) => {
            installmentAmounts[key] = value/continuityMonths.value;
        });
        var monthlyRadio = document.getElementById("continuityMonthly");
        monthlyRadio.checked = true;
        let installmentType = "month";

        this.props.setPaymentPlan(installmentType);
        this.props.setPaymentInstallments(continuityMonths.value);
        this.props.setPaymentInterval(1);
        this.props.setAuthAmounts(installmentAmounts);

        //check for not a number or lt the minimum or too many months
        if (Object.values(installmentAmounts).find(amt => isNaN(amt)) !== undefined || 
            continuityMonths.value>this.state.maximumMonths){ 
            this.setState({
                installmentAlertType: "alert alert-danger validation-message",
                continuityMonths: continuityMonths.value,
            });
            this.props.setPaymentPlanValidity(false);
        } else if (continuityMonths){
            this.setState({
                installmentAlertType: "alert alert-info",
                continuityMonths: continuityMonths.value,
            });
            this.props.setPaymentPlanValidity(true);
        }
        
        if (this.continuityMonthsInput !== document.activeElement) {
            this.continuityMonthsInput.focus();
        }
    }

    selectFullPayment(){
        this.setState({
            installmentAlertType: "alert alert-info"
        });
        let installmentType = "full";
        this.props.setPaymentPlan(installmentType);
        this.props.setPaymentInstallments(1);
        this.props.setPaymentInterval(1);
        this.props.setPaymentPlanValidity(true);
        this.props.setAuthAmounts(this.props.fullPayAmounts);
    }
    
    render() {
        return (
			<div>
                <InstallmentGuidelines installmentAlertType={this.state.installmentAlertType}/>
                <span className="text-default"><strong>Please select a payment option.</strong></span>
                <div className="radio">
                    <label htmlFor="continuityFull">
                        <input id="continuityFull" name="continuityType" type="radio" value="full" checked={this.props.paymentPlan === 'full'}
                            onChange={this.selectFullPayment} />
                        <strong>Pay in full</strong>
                    </label>
                    &nbsp;(${this.props.totalPaymentAmount||""})
                </div>
                <div className="radio">
                    <label htmlFor="continuityMonthly">
                        <input id="continuityMonthly" name="continuityType" type="radio" value="monthly" checked={this.props.paymentPlan === 'month'}
                            onChange={this.calculateMonthlyPayments} />
                        <strong>Pay monthly</strong>
                    </label>
                    &nbsp;(${(this.props.totalPaymentAmount/this.state.continuityMonths).toFixed(2)} for&nbsp;
                    <input type="number" value={this.state.continuityMonths} max={this.state.maximumMonths} 
                        min="2" id="continuityMonths" onChange={this.calculateMonthlyPayments} 
						autoComplete="off"
                        ref={this.setContinuityMonthsInputRef}/>&nbsp;months)
				</div>
            </div>
        );
    }
}

export default PaymentPlans;
